import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const me = await auth.me();
            setUser(me);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    const logout = async () => {
        try {
            await auth.logout();
        } catch {
            /* noop */
        }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, refresh, setUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
